import type { APIClientDTO, CompanyListing } from "@pentacode/core";

export function filterAPIClients<T extends Pick<APIClientDTO, "id" | "name">>(clients: T[], query: string): T[] {
    const needle = query.trim().toLowerCase();
    if (!needle) return clients;

    return clients.filter((c) => c.name.toLowerCase().includes(needle) || c.id.toLowerCase().includes(needle));
}

/** Companies the client does not have access to yet, narrowed by name or id. */
export function grantableCompanies<T extends Pick<CompanyListing, "id" | "name">>(
    companies: T[],
    client: Pick<APIClientDTO, "accesses">,
    query: string
): T[] {
    const granted = new Set(client.accesses.map((a) => a.companyId));
    const needle = query.trim().toLowerCase();

    return companies.filter(
        (c) =>
            !granted.has(c.id) && (!needle || c.name.toLowerCase().includes(needle) || c.id.toString().includes(needle))
    );
}
